import apiClient from "./index";

export const getCntxtPth = () => {
    return apiClient.get(`/sys/cntxtPth/findLatestCntxtPth.json`);
}

export const saveCntxtPth = cntxtPth => {
    return apiClient.post(`/admin/cntxtPth/saveProc.json`, cntxtPth);
}